<!--
Author: TangChen
Date: 2018-09-12
Desc: 获取图形验证码弹框，为公共组件
 -->
<template>
    <div class="comp-img-code comp">
        <el-dialog
            title=""
            :visible.sync="visible"
            width="500px"
            class="prop"
            v-on:close="dialogClose"
        >
            <el-form
                ref="form"
                :model="form"
                :rules="ruleVerify"
                class="form-contain"
                v-on:submit.native.prevent
            >
                <el-form-item label="">
                    <p class="prop-text">为了您的账户安全，请输入图形验证码</p>
                </el-form-item>
                <el-form-item label="" required>
                    <el-col :span="14">
                        <el-form-item label="" prop="verify">
                            <el-input
                                v-model.trim="form.verify"
                                class="img-code"
                                placeholder="请输入图形验证码"
                                :maxlength="4"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <span class="prop-verify">
                            <img class="verifyImg" alt="" :src="imgSrc" v-on:click="refresh" />
                        </span>
                    </el-col>
                </el-form-item>
            </el-form>
            <el-form slot="footer" class="dialog-footer">
                <el-button class="cancelBtn" v-on:click="dialogClose">取 消</el-button>
                <el-button class="confirmBtn" v-on:click="submitForm('form')">确 定</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "ImgCode",
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        biztype: {
            type: String,
            default: "4"
        }
    },
    data() {
        return {
            imgSrc: "", // 图片验证码请求地址
            form: {
                verify: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {
                // 验证码校验
                verify: [
                    {
                        validator: this.$util.validateImgVerifyCode,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        dialogVisible(val) {
            this.visible = val;
            if (!val) {
                this.$refs["form"].resetFields();
            } else {
                this.refresh();
            }
        }
    },
    /* 初始化加载数据 */
    mounted() {
        this.refresh();
    },
    methods: {
        /* 刷新验证码图片 */
        refresh() {
            this.$util.imgUrl(this.biztype).then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        /* 提交表单数据 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("verify-in", this.form.verify);
                } else {
                    this.$errorScroll();
                }
            });
        },
        dialogClose() {
            this.$emit("verify-in");
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-img-code {
    background: #ffffff;
    .verifyImg {
        width: 112px;
        height: 38px;
    }
    .prop-text {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
    }
    .form-contain {
        padding-left: 34px;
    }
    .cancelBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e4e4e4;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        border: 1px solid #e4e4e4;
        cursor: pointer;
    }
    .confirmBtn {
        width: 180px;
        height: 42px;
        border-radius: 2px;
        background: #e60012;
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid #e60012;
        cursor: pointer;
    }
    :deep(.el-dialog__header) {
        height: 40px;
        border-radius: 6px 6px 0px 0px;
        box-sizing: border-box;
        position: relative;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-dialog__headerbtn {
            position: relative;
            width: 19.99px;
            height: 19.99px;
            background: #ffffff;
            border: 1px solid #999999;
            box-sizing: border-box;
        }
        .el-dialog__headerbtn:hover {
            border: 1px solid #f61c14;
        }
        .el-icon-close {
            color: #999999;
        }
        .el-icon-close:before {
            color: #999999;
            font-size: 18px;
        }
        .el-icon-close:hover:before {
            color: #f61c14 !important;
        }
    }
}
</style>
